import confirmacionPaquetes from './components/confirmacion-pago/confirmacion-pago';
import GeneralConditions from './components/footer/GeneralConditions';
import TermsAndConditions from './components/footer/TermsAndConditions';
import formasDePago from './components/formas-de-pago/formas-de-pago';
import ConsultaDetalle from './components/layout/consulta-detalle/formulario-consulta-detalle';
import LayoutArrepentimiento from './components/layout/layout-arrepentimiento/layout-arrepentimiento';
import Consultas from './components/layout/layout-consulta-paquete/layout-consulta-paquetes';
import MapAgencies from './components/map-agencies/map-agencies';
import OfertaLista from './components/ofertas-lista/ofertas-lista';
import PaquetesCheckour from './components/paquetes-checkout/paquetes-checkout';
import PaquetesDetalle from './components/paquetes-detalle/paquetes-detalle';
import PaquetesLista from './components/paquetes-lista/paquetes-lista';
import PaquetesTematica from './components/paquetes-por-tematica/paquetes-lista';
import Reclamos from './components/reclamos/reclamos';
import OpenVoucherCheckout from './components/vouchers/checkout/index-checkout';
import OpenVoucherConfirmacion from './components/vouchers/confimation/index';
import OpenVoucherProductoDetalle from './components/vouchers/producto-detalle/index';
import OpenVoucherProductos from './components/vouchers/voucher-productos/index';
import OpenVoucher from './components/vouchers/vouchers-home/index-voucher';
import { ROUTE_KEYS } from './constants';
import FlightLayout from './layout/FlightLayout';
import BannerDetail from './views/banner-detalle/BannerDetail';
import CustomSection from './views/custom-section/custom-section';
import HomeView from './views/HomeView';
import PackageDetail from './views/paquete-detalle/PackageDetail';
import InternalPackageDetail from './views/paquete-detalle/InternalPackageDetail';
import PackageListPage from './views/paquetes/pages/PackageListPage';
import BookingPage from './views/vuelos/pages/BookingPage';
import FlightListPage from './views/vuelos/pages/FlightListPage';

const {
  HOME,
  BUSCAR_X_PAQUETES,
  BUSCAR_X_VUELOS,
  CONSULTA,
  CONSULTA_DETALLE,
  PAQUETE,
  BUSCAR_X_VUELOS_RESERVA,
  PAQUETES,
} = ROUTE_KEYS;

const routes = [
  {
    exact: true,
    path: HOME,
    component: HomeView,
  },
  {
    exact: true,
    path: BUSCAR_X_PAQUETES,
    component: PackageListPage,
  },
  {
    path: BUSCAR_X_VUELOS,
    component: () => (
      <FlightLayout>
        <FlightListPage />
      </FlightLayout>
    ),
    exact: true,
  },
  {
    path: BUSCAR_X_VUELOS_RESERVA,
    component: () => (
      <FlightLayout>
        <BookingPage />
      </FlightLayout>
    ),
    exact: true,
  },
  {
    path: '/buscarxpaquetes/ofertas',
    component: OfertaLista,
  },
  {
    path: '/buscarxpaquetes/lista-de-paquetes',
    component: PaquetesLista,
  },
  {
    path: '/buscarxpaquetes/viajes',
    component: PaquetesDetalle,
  },
  {
    path: '/checkout',
    component: PaquetesCheckour,
  },
  {
    path: '/buscarxpaquetes/confirmacion-pago',
    component: confirmacionPaquetes,
  },
  {
    path: '/buscarxpaquetes/consulta',
    component: Consultas,
  },
  {
    path: '/buscarxpaquetes/arrepentimiento',
    component: LayoutArrepentimiento,
  },
  {
    path: '/buscarxpaquetes/tematica',
    component: PaquetesTematica,
  },
  {
    path: '/buscarxpaquetes/open-voucher',
    component: OpenVoucher,
    exact: true,
  },
  {
    path: '/buscarxpaquetes/open-voucher/productos/:id1/:id2',
    component: OpenVoucherProductos,
  },
  {
    path: '/buscarxpaquetes/open-voucher/producto-detalle/:id1/:id2/:id3',
    component: OpenVoucherProductoDetalle,
  },
  {
    path: '/buscarxpaquetes/open-voucher/checkout/:id1/:id2',
    component: OpenVoucherCheckout,
  },
  {
    path: '/buscarxpaquetes/open-voucher/confirmacion',
    component: OpenVoucherConfirmacion,
  },
  // provitional routes ⏳
  {
    path: '/packages/ofertas',
    component: OfertaLista,
  },
  {
    path: '/packages/lista-de-paquetes/:origin/:destination/:monthString/:distribution',
    component: PaquetesLista,
  },
  {
    path: '/packages/viajes',
    component: PaquetesDetalle,
  },
  {
    path: '/packages/checkout',
    component: PaquetesCheckour,
  },
  {
    path: '/packages/confirmacion-pago',
    component: confirmacionPaquetes,
  },
  {
    path: '/packages/consulta',
    component: Consultas,
  },
  {
    path: '/packages/arrepentimiento',
    component: LayoutArrepentimiento,
  },

  // New regional routes ✨
  {
    path: '/packages/ofertas',
    component: OfertaLista,
  },
  {
    path: '/packages/list/:origin/:destination/:monthString/:distribution',
    component: PaquetesLista,
  },
  {
    path: '/packages/trips',
    component: PaquetesDetalle,
  },
  {
    path: '/packages/checkout',
    component: PaquetesCheckour,
  },
  {
    path: '/packages/payment-confirmation',
    component: confirmacionPaquetes,
  },
  {
    path: '/packages/consultation',
    component: Consultas,
  },
  {
    path: '/general-conditions',
    component: GeneralConditions,
  },
  {
    path: '/terms-and-conditions',
    component: TermsAndConditions,
  },
  {
    path: '/claims',
    component: Reclamos,
  },
  {
    path: '/s/:id/:title',
    component: CustomSection,
  },
  {
    exact: true,
    path: '/packages',
    component: HomeView,
  },
  {
    path: '/packages/details',
    component: PaquetesDetalle,
  },
  {
    path: '/agencies',
    component: MapAgencies,
  },
  {
    path: '/pay-methods',
    component: formasDePago,
  },
  {
    path: `${CONSULTA}/:id`,
    component: BannerDetail,
  },
  {
    path: `${CONSULTA_DETALLE}/:id`,
    component: ConsultaDetalle,
  },
  {
    path: `${PAQUETE}/:id`,
    component: PackageDetail,
  },
  {
    path: `${PAQUETES}/:id`,
    component: InternalPackageDetail,
  },
  {
    path: PAQUETES,
    component: InternalPackageDetail,
  },
];

export default routes;
